// ============================================================================
// Nights on a service line. A handover is one date (TCSD-0336): the incoming
// sub's first night is stated, and the outgoing sub's last night is always the
// night before it. These are bare calendar dates, so they never go through a
// timestamp or toISOString(), which is UTC and turns tonight into tomorrow after
// 7pm in Kansas.
// ============================================================================

/** A local calendar date as YYYY-MM-DD. */
export function localIsoDate(d: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** The night before a bare YYYY-MM-DD date. Month and year ends roll correctly. */
export function nightBefore(d: string): string {
  const [y, m, day] = d.split('-').map(Number);
  return localIsoDate(new Date(y, m - 1, day - 1));
}

/** "Fri Sep 4". */
export function fmtNight(d: string | null): string {
  if (!d) return '';
  const [y, m, day] = d.split('-').map(Number);
  return new Date(y, m - 1, day).toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}
